import React from 'react';
import { Carousel } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import './seccionesFicha.css'

const Slider = ({ multimedia, vehiculo }) => {

    if (!multimedia || multimedia.length < 1) return null;
    if (!vehiculo) return null;
    return (
        <Carousel className="slider-flechas">
            {multimedia && multimedia.length > 0 &&
                multimedia.map((archivo, i) => archivo.Tipo === "IMG" ?
                    <Carousel.Item key={i}>
                        <h1 className=" bold-title-hyundai d-none d-md-block position-title text-shadow-title mb-0">{vehiculo.Nombre}
                        <span><h5 className=" d-none d-md-block parrafo-hyundai text-shadow-title my-2 text-white">{vehiculo.descripcionCorta}</h5></span></h1>
                        <p className="bold-title-hyundai font-title-mobile position-title text-shadow-title d-md-none mx-2 mt-0 w-100">{vehiculo.Nombre}
                        <span className="parrafo-hyundai f-subtitle-mobile text-white text-shadow-title d-block d-md-none ">{vehiculo.descripcionCorta}</span>
                        </p>
                        <img src={archivo.Multimedia} alt={vehiculo.Nombre} className="img-fluid slider-lg" />
                    </Carousel.Item>
                    : <Carousel.Item key={i} className="player-wrapper-slider">
                        <ReactPlayer width="100%" height="100%" className="hyundai-video-player slider-lg" url={archivo.Multimedia} />
                    </Carousel.Item>
                )
            }

        </Carousel>
    );
}

export default Slider;